var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10173_10908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 0.666504H8.00033C7.6467 0.666504 7.30757 0.80698 7.05752 1.05703C6.80747 1.30708 6.66699 1.64622 6.66699 1.99984V13.9998C6.66699 14.3535 6.80747 14.6926 7.05752 14.9426C7.30757 15.1927 7.6467 15.3332 8.00033 15.3332H14.0003C14.3539 15.3332 14.6931 15.1927 14.9431 14.9426C15.1932 14.6926 15.3337 14.3535 15.3337 13.9998V1.99984C15.3337 1.64622 15.1932 1.30708 14.9431 1.05703C14.6931 0.80698 14.3539 0.666504 14.0003 0.666504Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 1.6665C4.6467 1.6665 4.30756 1.80698 4.05752 2.05703C3.80747 2.30708 3.66699 2.64622 3.66699 2.99984V12.9998C3.66699 13.3535 3.80747 13.6926 4.05752 13.9426C4.30756 14.1927 4.6467 14.3332 5.00033 14.3332",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 2.6665C1.6467 2.6665 1.30757 2.80698 1.05752 3.05703C0.807468 3.30708 0.666992 3.64622 0.666992 3.99984V11.9998C0.666992 12.3535 0.807468 12.6926 1.05752 12.9426C1.30757 13.1927 1.6467 13.3332 2.00033 13.3332",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.5C11.663 10.5 12.2989 10.2366 12.7678 9.76777C13.2366 9.29893 13.5 8.66304 13.5 8C13.5 7.33696 13.2366 6.70107 12.7678 6.23223C12.2989 5.76339 11.663 5.5 11 5.5C10.337 5.5 9.70107 5.76339 9.23223 6.23223C8.76339 6.70107 8.5 7.33696 8.5 8C8.5 8.66304 8.76339 9.29893 9.23223 9.76777C9.70107 10.2366 10.337 10.5 11 10.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8777 8.29223H10.791V7.20557",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10173_10908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionIcon);
export default __webpack_public_path__ + "static/media/Version_icon.26ea73b8.svg";
export { ForwardRef as ReactComponent };